module.exports = __webpack_public_path__ + "static/media/gif-dimen1.c13e454f.gif";